import { Component, OnInit } from '@angular/core';
import { switchMap, EMPTY, of, catchError, tap } from 'rxjs';
import { DevCycleService } from '@services/dev-cycle.service';

@Component({
  selector: 'ew-withdraw-money',
  template: `
    <ng-container *ngIf="isLoading">
      <p>Loading feature flag...</p>
    </ng-container>
    <ng-container *ngIf="hasError">
      <p>Error loading feature flag. Please try again later.</p>
    </ng-container>
    <ng-container *ngIf="!isLoading && !hasError">
      <ng-container *ngIf="notificationsToProvidersFeatureFlag; else v1">
        <ew-withdraw-money-v2 #withdrawMoneyV2></ew-withdraw-money-v2>
      </ng-container>
      <ng-template #v1>
        <ew-withdraw-money-v1></ew-withdraw-money-v1>
      </ng-template>
    </ng-container>
  `,
})
export class WithdrawMoneyComponent implements OnInit {
  notificationsToProvidersFeatureFlag!: boolean;
  isLoading: boolean = true;
  hasError: boolean = false;

  constructor(private CYCLE: DevCycleService) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.hasError = false;
    of(this.CYCLE.getVariable('ew-3078-notifications-to-providers', false))
      .pipe(
        switchMap(async (featureFlagPromise) => await featureFlagPromise),
        tap((flag) => {
          this.notificationsToProvidersFeatureFlag = flag;
          this.isLoading = false;
        }),
        catchError((error) => {
          console.error(
            `[NG_ON_INIT | ERROR]: Error loading notificationsToProvidersFeatureFlag === ${error.message}`,
            error.stack,
            'NG_ON_INIT | ERROR',
          );
          this.hasError = true;
          this.isLoading = false;
          return EMPTY;
        }),
      )
      .subscribe();
  }
}
